import * as React from 'react';

import classNames from 'classnames';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

import 'css!bundles/page/components/__styles__/MobileBreadCrumb';

type Props = {
  href: string;
  label: string;
  styles?: React.CSSProperties;
};

const MobileBreadCrumb = ({ href, label, styles }: Props) => {
  if (!label || !href) {
    return null;
  }

  const wrapperClasses = classNames('rc-mobileBreadcrumb', 'breadcrumbs-list');

  return (
    <div className={wrapperClasses} style={{ ...styles }}>
      <TrackedLink2 className={classNames('mobile-breadcrumb-link')} href={href} trackingName="mobile_breadcrumb_link">
        <span className="breadcrumb-item-divider" aria-hidden="true">
          &#60;
        </span>
        <span className="breadcrumb-item">{label}</span>
      </TrackedLink2>
    </div>
  );
};

export default MobileBreadCrumb;
